import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'textHighlight'
})
export class TextHighlightPipe implements PipeTransform {
  constructor() {
  }

  transform(value: string, text: string | undefined, cssClass: string): unknown {
    return text ? value.replace(text, `<span class="${cssClass}">${text}</span>`) : value
  }

}
